module.exports = __webpack_public_path__ + "static/img/BN@2x.d85a8d0b.jpg";